package com.cybersoftsolution.cybersoftsolutionweb.components.checkbox

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyBorderRadius

import com.cybersoftsolution.cybersoftsolutionweb.styles.MyCheckBoxStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.checkBoxId
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs

import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput

    @Composable
    fun MyCheckBox(
        borderRadius: CSSSizeValue<CSSUnit.px> = 15.px,
        text: String = "",
        modifier: Modifier = Modifier,
        checked: Boolean,
        onClick: ()-> Unit = {},

        ){

        var isChecked by remember { mutableStateOf(checked) }

        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start,

            modifier = MyCheckBoxStyle.toModifier()

                .id(checkBoxId)
                .borderRadius(borderRadius)
                .padding(leftRight = 12.px)
                .cursor(Cursor.Pointer)
                .margin(leftRight = 6.px)
//                                .width(350.px)
                .height(32.px)
                .onClick {
                    isChecked = !isChecked
                    onClick()
                }
                .then(modifier)
            ,

            ) {
            CheckboxInput(
                checked = isChecked,
                attrs = MyCheckBoxStyle.toModifier()
                    .id(IdConst.checkBoxRememberLogin)
                    .height(24.px)
                    .width(24.px)
                    .fontSize(16.px)
                    .cursor(Cursor.Pointer)
                    .backgroundColor(Colors.Black)
                    .toAttrs{

//                                        onClick {
//                                            isChecked = !isChecked
//                                        }
                    }

            )
            SpanText(
                text = text,
                modifier = Modifier
                    .margin(left = 8.px)
                    .fillMaxHeight(80.percent)
                    .color(Colors.Black)
                    .fontSize(FontSize.Medium)
//                                    .cursor(Cursor.Pointer)
//                                    .onClick {
//                                        isChecked = !isChecked
//                                    }


            )
        }









        //                        Row(
//                            verticalAlignment = Alignment.CenterVertically,
//                            horizontalArrangement = Arrangement.Start,
//
//                            modifier = PrimaryButtonStyle.toModifier()
//                                .id(primaryButtonId)
//                                .borderRadius(24.px)
//                                .padding(leftRight = 12.px)
//                                .cursor(Cursor.Pointer)
//                                .margin(bottom = 12.px,leftRight = 12.px)
////                                .width(350.px)
//                                .height(32.px)
//                                .onClick {
//                                    isChecked = !isChecked
//                                }
//                            ,
//
//                        ) {
//                            CheckboxInput(
//                                checked = isChecked,
//                                attrs = CheckBoxStyle.toModifier()
//                                    .id(id.checkBoxRememberLogin)
//                                    .height(24.px)
//                                    .width(24.px)
//                                    .fontSize(16.px)
//                                    .cursor(Cursor.Pointer)
//                                    .toAttrs{
////                                        onClick {
////                                            isChecked = !isChecked
////                                        }
//                                    }
//
//                            )
//                            SpanText(
//                                text = "Recordarme",
//                                modifier = Modifier
//                                    .margin(left = 8.px)
//                                    .fillMaxHeight(80.percent)
//                                    .color(Colors.Black)
//                                    .fontSize(FontSize.Medium)
////                                    .cursor(Cursor.Pointer)
////                                    .onClick {
////                                        isChecked = !isChecked
////                                    }
//
//
//                            )
//                        }
//



    }